import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Ushindi";

const UshindiGardens = () => {
  const projectId = "PRJ00046";
  const title = "Ushindi Gardens";

  const mapConfig = {
    minZoom: 2.8,
    zoom: 3.2,
    bounds: [
      [48.6, -155.72],
      [-75.79, 57.68],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/ushindi-gardens-nakuru/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSeA_WqK4YWveQx7l9htk2uTFNwbdHx0PV9IikTlrs91Dkvw7Q/viewform"
    />
  );
};

export default UshindiGardens;
